import type React from 'react';
import BlandCallMessage from 'src/components/job-slide-out/components/nav-table/tenant-lula-chat/messages/bland-call-message';
import CallLogMessage from 'src/components/job-slide-out/components/nav-table/tenant-lula-chat/messages/call-log-message';
import LumiMessage from 'src/components/job-slide-out/components/nav-table/tenant-lula-chat/messages/lumi-message';
import MediaMessage from 'src/components/job-slide-out/components/nav-table/tenant-lula-chat/messages/media-message';
import ScheduledMessage from 'src/components/job-slide-out/components/nav-table/tenant-lula-chat/messages/scheduled-message';
import SystemMessage from 'src/components/job-slide-out/components/nav-table/tenant-lula-chat/messages/system-message';
import TextBubble from 'src/components/job-slide-out/components/nav-table/tenant-lula-chat/messages/text-bubble';
import { shouldRenderSmsMessageAsMedia } from 'src/components/job-slide-out/components/nav-table/tenant-lula-chat/utils';
import type { TenantContactMessage } from 'src/types';

interface MessageItemProps {
	message: TenantContactMessage;
	contactName: string;
	jobTimezone: string;
}

const SCHEDULED_TYPES = ['scheduled-sms', 'scheduled-automated-sms'];

const MessageItem: React.FC<MessageItemProps> = ({
	message,
	contactName,
	jobTimezone,
}) => {
	const type = message.notification_type;

	if (type === 'bland-call')
		return <BlandCallMessage message={message} jobTimezone={jobTimezone} />;
	if (type === 'lumi-notification') return <LumiMessage message={message} />;
	if (type === 'system-notification')
		return <SystemMessage message={message} jobTimezone={jobTimezone} />;
	if (type && SCHEDULED_TYPES.includes(type))
		return <ScheduledMessage message={message} jobTimezone={jobTimezone} />;
	if (type === 'call-log')
		return <CallLogMessage message={message} jobTimezone={jobTimezone} />;
	if (shouldRenderSmsMessageAsMedia(message))
		return <MediaMessage message={message} jobTimezone={jobTimezone} />;
	return (
		<TextBubble
			message={message}
			tenantName={contactName}
			jobTimezone={jobTimezone}
		/>
	);
};

export default MessageItem;
